module.exports = __webpack_public_path__ + "img/icons/loom-logo-mark-white-3a0d312bc47704fae8b92452b4cdcdfc.svg";